import { DefaultTheme } from 'styled-components';
import {
  fontScales,
  FontScales,
  fontWeights,
  FontWeights,
  colors,
  Colors,
  textTransforms,
  TextTransforms,
  textAligns,
  TextAligns,
} from './config';

declare module 'styled-components' {
  export interface DefaultTheme {
    colors: Colors;
    fontScales: FontScales;
    fontWeights: FontWeights;
    textTransforms: TextTransforms;
    maxWidth: string;
    transitionSpeed: string;
    headerHeight: string;
    borderRadius: Record<string, string>;
    sidebarWidth: string;
    textAligns: TextAligns;
  }
}

const theme: DefaultTheme = {
  colors,
  fontWeights,
  textTransforms,
  textAligns,
  borderRadius: {
    base: '0.3rem',
    big: '0.5rem',
    big2: '1.6rem',
  },
  fontScales,
  maxWidth: '117rem',
  headerHeight: '6rem',
  transitionSpeed: '200ms',
  sidebarWidth: '24rem',
};

export { theme };
